import { render } from "./AktivitetItem.vue?vue&type=template&id=7ba7371d"
import script from "./AktivitetItem.vue?vue&type=script&lang=js"
export * from "./AktivitetItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__